import { Component, Inject, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import {
  AdaptiveAccessNodeRuleset,
  AdaptiveAccessControlNode,
  Header,
  Ruleset,
} from "@aptsi-types";
import { AdaptiveAccessNodeService } from "../adaptive-access-node.service";
import { ErrorDialogComponent } from "../../shared/dialogs/error-dialog.component";
import { AdaptiveAccessNodeRulesetService } from "../../adaptive-access-node-ruleset/adaptive-access-node-ruleset-create-or-update/adaptive-access-node-ruleset.service";
import { DeleteDialogComponent } from "../../shared/dialogs/delete-dialog/delete-dialog.component";
import { RulesetService } from "../../ruleset/ruleset.service";
import { SuccessDialogComponent } from "../../shared/dialogs/success-dialog/success-dialog.component";
import { AdaptiveAccessNodeRulesetCreateOrUpdateDialogComponent } from "../../adaptive-access-node-ruleset/adaptive-access-node-ruleset-create-or-update/adaptive-access-node-ruleset-create-or-update.component";
import { KeycloakStateService } from 'src/app/core/service/utility.service';
import { EnvironmentService } from "src/app/core/service/environment.service";

@Component({
  selector: "app-adaptive-access-node-create-or-update",
  templateUrl: "./adaptive-access-node-create-or-update.component.html",
  styleUrls: ["./adaptive-access-node-create-or-update.component.scss"],
})
export class AdaptiveAccessNodeCreateOrUpdateComponent implements OnInit {
  // -------------------- UI Header Configuration --------------------
  headers: Header[] = [
    { name: "Ruleset Type", property: "ruleSetType" },
    { name: "Ruleset Id", property: "ruleSetId" }
  ];

  updateHeaders: Header[] = [
    { name: "AAC Ruleset Id", property: "adaptiveAccessNodeRulesetId" },
    { name: "Ruleset Type", property: "ruleSetType" },
    { name: "Ruleset Id", property: "ruleSetId" }
  ];

  get currentHeaders() {
    return this.isCreate ? this.headers : this.updateHeaders;
  }

  selectedTab: 'adaptiveAccessNode' | 'adaptiveAccessNodeRuleset' = 'adaptiveAccessNode';

  readonly typeOptions = ["INITIAL", "FEDERATED", "TERMINAL", "None"];
  readonly protocolOptions = ["OAUTH2", "None"];

  // -------------------- Context Flags & IDs --------------------
  isCreate:boolean = false;
  isCreateForUpdate = false;
  isNext = false;

  //existingadAptiveAccessNodeId: string = null;
  existingAdaptiveAccessNodeId: string = null;
  existingAdaptiveAccessNodeRulesetId: string = this.adaptiveAccessNodeRulesetService.getAdaptiveAccessNodeRulesetId();
  organizationId: string;
  showModal = false;

  // -------------------- Data & Form --------------------
  adaptivesccessnode: AdaptiveAccessControlNode = null;
  adaptiveAccessNodeRuleset: AdaptiveAccessNodeRuleset[] = [];
  rulesets: Ruleset[] = [];
  filteredDataToSearch: any[] = [];
  filteredHeaders: Header[];

  form: FormGroup;

  nullver: number = null;

  buttonConfig = {
    update: true,
    delete: true,
    import: false,
    configure: false
  };

  if(isCreate){
    this.buttonConfig = {
      update: false,
      delete: true,
      import: false,
      configure: false
    };
  }

    handleAction(event: {
      action: string;
      rowIndex: number;
      rowData: AdaptiveAccessNodeRuleset;
    }): void {
      if (event.action === "update") {
        this.updateAdaptiveAccessNodeRuleset(event.rowIndex);
      } else if (event.action === "delete") {
        this.deleteAdaptiveAccessNodeRuleset(event.rowIndex);
      }
    }
  


  // -------------------- Constructor --------------------
  constructor(
    private route: ActivatedRoute,
    private adaptiveAccessControlService: AdaptiveAccessNodeService,
    private adaptiveAccessNodeRulesetService: AdaptiveAccessNodeRulesetService,
    private dialog: MatDialog,
    private router: Router,
    private rulesetService: RulesetService,
    private adaptiveAccessNodeService: AdaptiveAccessNodeService,
    private keycloakStateService: KeycloakStateService,
    public environmentService: EnvironmentService 
  ) { }

  // --------------------  Lifecycle --------------------
  async ngOnInit(): Promise<void> {
    this.organizationId = this.keycloakStateService.getOrganizationId(); // <-- Retrieve here
    console.log('Organization ID in component:', this.organizationId);
    this.isCreate = Boolean(this.route.snapshot.data.create);
    this.existingAdaptiveAccessNodeId = this.route.snapshot.params.adaptiveAccessNodeId;

    if (!this.isCreate) {
      await this.fetchAdaptiveAccessNode();
      await this.fetchAdaptiveAccessNodeRuleset();
      this.isNext = true;
    }

    this.initializeForm();

    if (this.isCreate) {
      this.adaptiveAccessNodeRulesetService.nodeRulesets$.subscribe((entries) => {
        this.adaptiveAccessNodeRuleset = entries;
        console.log('inside ngonit', this.adaptiveAccessNodeRuleset);
      });
    }
  }

  // -------------------- Form & Validators --------------------
  initializeForm(): void {
    // const adaptiveNode = this.adaptivesccessnode;

    // this.form = new FormGroup({
    //   adaptiveAccessNodeId: new FormControl(this.existingadAptiveAccessNodeId, Validators.required),
    //   adaptiveAccessNodeName: new FormControl(adaptiveNode?.adaptiveAccessNodeName || null, Validators.required),
    //   adaptiveAccessNodeType: new FormControl(adaptiveNode?.adaptiveAccessNodeType || "None", [
    //     Validators.required, this.typeValidator,
    //   ]),
    //   authenticationProtocol: new FormControl(adaptiveNode?.authenticationprotocol || "None", [
    //     Validators.required, this.typeValidator,
    //   ]),
    //   authenticationEndpoint: new FormControl(adaptiveNode?.authenticationendpoint || null, Validators.required),
    // });

    // if (this.isCreate) {
    //   this.form.removeControl("adaptiveAccessNodeId");
    // }

    if (this.isCreate) {
      this.form = new FormGroup({
        //adaptiveAccessNodeId: new FormControl(this.existingadAptiveAccessNodeId, Validators.required),
        adaptiveAccessNodeName: new FormControl(null, Validators.required),
        adaptiveAccessNodeType: new FormControl("None", [
          Validators.required, this.typeValidator,
        ]),
        authenticationProtocol: new FormControl("None", [
          Validators.required, this.typeValidator,
        ]),
        authenticationEndpoint: new FormControl(null, Validators.required),
      });
    } else {
      this.form = new FormGroup({
        adaptiveAccessNodeId: new FormControl(this.existingAdaptiveAccessNodeId, Validators.required),
        adaptiveAccessNodeName: new FormControl(this.adaptivesccessnode.adaptiveAccessNodeName || null, Validators.required),
        adaptiveAccessNodeType: new FormControl(this.adaptivesccessnode.adaptiveAccessNodeType || "None", [
          Validators.required, this.typeValidator,
        ]),
        authenticationProtocol: new FormControl(this.adaptivesccessnode.authenticationprotocol || "None", [
          Validators.required, this.typeValidator,
        ]),
        authenticationEndpoint: new FormControl(this.adaptivesccessnode.authenticationendpoint || null, Validators.required),
      });
    }
  }

  typeValidator(control: AbstractControl): { [key: string]: any } | null {
    return control.value === "None" ? { noneSelected: true } : null;
  }

  // -------------------- Data Fetching --------------------
  async fetchAdaptiveAccessNode(): Promise<void> {
    try {
      const response = await this.adaptiveAccessControlService
        .getAdaptiveAccessNode(this.existingAdaptiveAccessNodeId).toPromise();

      this.adaptivesccessnode = response["Resource retrieved successfully"]?.[0] || null;

      if (this.adaptivesccessnode) {
        this.form.patchValue({
          adaptiveAccessNodeName: this.adaptivesccessnode.adaptiveAccessNodeName,
          rulesetId: this.adaptivesccessnode.rulesetId,
          adaptiveAccessNodeType: this.adaptivesccessnode.adaptiveAccessNodeType,
          authenticationProtocol: this.adaptivesccessnode.authenticationprotocol,
          authenticationEndpoint: this.adaptivesccessnode.authenticationendpoint,
        });
      }
    } catch (error) {
      console.error("Error fetching node:", error);
    }
  }

  async fetchAdaptiveAccessNodeRuleset(): Promise<void> {
    try {
      const response = await this.adaptiveAccessNodeRulesetService
        .getAdaptiveAccessNodeRulesetByaccessNodeId(this.existingAdaptiveAccessNodeId).toPromise();
      this.adaptiveAccessNodeRuleset = response["Resource retrieved successfully"] || [];
    } catch (error) {
      console.error("Error fetching ruleset:", error);
    }
  }

  async fetchAdaptiveAccessNodeRulesetStage(): Promise<void> {
    const response = await this.adaptiveAccessNodeRulesetService.getAdaptiveAccessNodeRulesetStage().toPromise();
    this.adaptiveAccessNodeRuleset = response["Resource retrieved successfully"] || [];
  }

  // -------------------- 🔍 Search & Utility --------------------
  lookup(e: string): void {
    this.filteredDataToSearch = this.rulesets
      .filter(i => i.name.toLowerCase().includes(e))
      .map(w => ({ text: w.name, value: w.rulesetid }));
  }

  clean(t: any): void {
    t.value = "";
    this.lookup("");
  }

  // -------------------- Create / Update Logic --------------------
  async submit(): Promise<void> {
    try {
      if (this.isCreate) {
        const response = await this.adaptiveAccessControlService
          .createadaptiveaccessnodes(
            this.form.value.adaptiveAccessNodeName,
            this.form.value.adaptiveAccessNodeType,
            this.organizationId,
            this.form.value.authenticationProtocol,
            this.form.value.authenticationEndpoint
          ).toPromise();

        this.adaptivesccessnode = response["Resource created successfully"]?.[0] || null;
        if (this.adaptivesccessnode) {
          this.existingAdaptiveAccessNodeId = this.adaptivesccessnode.adaptiveaccessnodeid;
        }

        console.log("Adaptive Access Node created:", this.existingAdaptiveAccessNodeId);

        this.isNext = true;
        this.selectedTab = 'adaptiveAccessNodeRuleset';
      } else {
        await this.adaptiveAccessControlService
          .updateadaptiveaccessnodes(
            this.existingAdaptiveAccessNodeId,
            this.form.value.adaptiveAccessNodeName,
            this.form.value.adaptiveAccessNodeType,
            this.organizationId,
            this.form.value.authenticationProtocol,
            this.form.value.authenticationEndpoint
          ).toPromise();

        this.openSuccessDialog(false);
      }
    } catch (error) {
      this.openErrorDialog(error.message || "An unexpected error occurred.");
    }
  }

  async finish(): Promise<void> {
    await this.adaptiveAccessNodeService.finishProcess().toPromise();
    this.openSuccessDialog(this.isCreate);
  }

  // -------------------- Delete Logic --------------------
  async deleteAdaptiveAccessNodeRuleset(index: number): Promise<void> {
    try {
      const dialogRef = this.dialog.open(DeleteDialogComponent, {
        data: {
          title: "Are you sure?",
          message: "Do you really want to delete this Node Ruleset?",
          isConfirm: false,
        },
      });

      const result = await dialogRef.afterClosed().toPromise();

      if (result) {
        if (!this.isCreate) {
          await this.adaptiveAccessNodeRulesetService
            .deleteAdaptiveAccessNodeRuleset(this.adaptiveAccessNodeRuleset[index].adaptiveAccessNodeRulesetId).toPromise();
          this.fetchAdaptiveAccessNodeRuleset();
        } else {
          await this.adaptiveAccessNodeRulesetService
            .deleteAdaptiveAccessNodeRulesetStage(this.adaptiveAccessNodeRuleset[index].ruleSetId).toPromise();
          this.fetchAdaptiveAccessNodeRulesetStage();
          this.adaptiveAccessNodeRuleset.splice(index, 1);

          console.log("Adaptive Access Node Ruleset deleted:", this.adaptiveAccessNodeRuleset);
        }

        this.dialog.open(DeleteDialogComponent, {
          data: {
            title: "Successful",
            message: "The Node Ruleset has been deleted successfully.",
            isConfirm: true,
          },
        });
      }
    } catch (error) {
      console.error("Error deleting ruleset:", error);
    }
  }

  // -------------------- Update Ruleset Dialog --------------------
  async updateAdaptiveAccessNodeRuleset(index: number): Promise<void> {
    const dialogRef = this.dialog.open(AdaptiveAccessNodeRulesetCreateOrUpdateDialogComponent, {
      data: {
        title: "Accessflow Ruleset Deleted Successfully",
        message: "The accessflow ruleset has been deleted successfully.",
        isCreate: false,
        adaptiveAccessNodeId: this.existingAdaptiveAccessNodeId,
        adaptiveAccessNodeRulesetId: this.adaptiveAccessNodeRuleset[index].adaptiveAccessNodeRulesetId,

      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) this.fetchAdaptiveAccessNodeRuleset();
    });
  }

  redirectToAdaptiveAccessNodeRulesetCreate(): void {
    // this.existingAdaptiveAccessNodeId = this.isCreate ? null : this.form.value.adaptiveAccessNodeId;
    this.isCreateForUpdate = !this.isCreate ? true : false;

    const dialogRef = this.dialog.open(AdaptiveAccessNodeRulesetCreateOrUpdateDialogComponent, {

        width: "1400px",
        maxWidth: "1400px",
        height: "800px",
      data: {
        title: "Accessflow Ruleset Deleted Successfully",
        message: "The accessflow ruleset has been deleted successfully.",
        isCreate: true,
        isCreateForUpdate: this.isCreateForUpdate,
        adaptiveAccessNodeId: this.existingAdaptiveAccessNodeId,
      },
      
    });

    if (!this.isCreate) {
      dialogRef.afterClosed().subscribe((result) => {
        if (result) this.fetchAdaptiveAccessNodeRuleset();
      });
    }
  }

  // -------------------- Dialogs --------------------
  openSuccessDialog(isCreate: boolean): void {
    const dialogRef = this.dialog.open(SuccessDialogComponent, {
      width: "250px",
      data: { isCreate, title: "Adaptive Access Node" },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.router.navigate(["ada-access/auth-tools/adaptiveaccessnode/search"]);
    });
  }

  openErrorDialog(errorMessage: string): void {
    this.dialog.open(ErrorDialogComponent, {
      width: "250px",
      data: { errorMessage },
    });
  }

  openDeleteDialog(errorMessage: string): void {
    this.dialog.open(DeleteDialogComponent, {
      width: "250px",
      data: { errorMessage },
    });
  }

  // -------------------- Cancel --------------------
  cancel(): void {
    this.router.navigate(["ada-access/auth-tools/adaptiveaccessnode/search"]);
  }
}
